(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3_rs_theme = {})));
}(this, (function (exports) { 'use strict';

var version = "0.6.0";

var L_TH = 64;

// Start: Adapted from https://github.com/MoOx/color-convert
// MIT : https://github.com/MoOx/color-convert/blob/master/LICENSE
// Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function lab2xyz(lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;
	var y2;

	if (l <= 8) {
		y = (l * 100) / 903.3;
		y2 = (7.787 * (y / 100)) + (16 / 116);
	} else {
		y = 100 * Math.pow((l + 16) / 116, 3);
		y2 = Math.pow(y / 100, 1 / 3);
	}

	x = x / 95.047 <= 0.008856
		? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787
		: 95.047 * Math.pow((a / 500) + y2, 3);
	z = z / 108.883 <= 0.008859
		? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787
		: 108.883 * Math.pow(y2 - (b / 200), 3);

	return [x, y, z];
}

function xyz2rgb(xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r *= 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g *= 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b *= 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
}

function lab2rgb(lab) {
  return xyz2rgb(lab2xyz(lab)).map(function (c) { return Math.round(c); });
}

// End : Adapted from https://github.com/MoOx/color-convert

function rgbToHex(hex) {
  return '#' + hex[0].toString(16) + '' + hex[1].toString(16) + '' + hex[2].toString(16);
}

function hexToRgb(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    // console.log('Could not parse color', hex);
    return [0, 0, 0];
  }
  return [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ];
}

function encode(s) {
  if (typeof s === 'string' || s instanceof String) {
    return Math.abs(s.split('').reduce(function (a,b) { a=((a<<5)-a)+b.charCodeAt(0); return a&a }, 0));  
  } 
  
  if (typeof s === 'number') { 
    var r = (s % 1);
    if (r === 0) {
      return s;
    }
  }
  return null;           
}

function transformLighness(c, v) {
  if (typeof c === 'string' || c instanceof String) {
    c = hexToRgb(c);
  }
  var lab = rgb2lab(c);
  lab[0] = lab[0] * v;
  return lab2rgb(lab);
}

var Transform = {
  lightness: transformLighness,
  light: function (c) { return rgbToHex(transformLighness(c, 1.6)); },
  medium: function (c) { return rgbToHex(transformLighness(c, 1.3)); }
};

var Contrasts = {
  // Check the colour supplied can have white text
  // composited on top with the required contrast for reading
  white: function(c) {
    if (typeof c === 'string' || c instanceof String) {
      c = hexToRgb(c);
    }
    var lab = rgb2lab(c);
    return (lab[0] < L_TH);
  }
};

var Sort = {
  lightness: function(colors) {
    var lab = colors.map(function(c) {
      var a = c;
      if (!Array.isArray(c)) {
        a = hexToRgb(c);
      }
      
      return [rgb2lab(a), c];
    });
    
    var sort = lab.sort(function(a, b) {
      if (a[0][0] < b[0][0]) return -1;
      if (a[0][0] > b[0][0]) return -1;
      return 0;
    });
    
    return sort.map(function (a) { return a[1]; });
  }
};

// Random color from theme, optionally derived from the input 's'
function random(palette, rng) {
  if (rng == null) rng = Math.random;
  
  return function _random(s) {
    var hash = encode(s);
    if (hash == null) {
      hash = Math.floor(rng() * palette.length);
    } else {
      hash = hash % palette.length;
    }
    
    return palette[hash];
  }
}

// Informed by the Cagatay Demiralp paper, grey is moved around to break
// brown and red in this color scheme

var presentation10dark = [ 
    '#00ce5c', // Green
    '#d800a2', // Pink          
    '#00d9d2', // Aqua     
    '#AF5100', // Brown         
    '#bfbfbf', // Grey   
    '#DE0000', // Red     
    '#F0DE00', // Yellow           
    '#9200ff', // Purple      
    '#ED9200', // Orange     
    '#00aeff' // Blue 
];

var presentation10std = [ 
   
    '#56d58e', // Green
    '#d95cba', // Pink          
    '#63eae4', // Aqua     
    '#C78348', // Brown         
    '#d6d6d6', // Grey 
    '#E06363', // Red     
    '#FFF741', // Yellow           
    '#965ede', // Purple      
    '#FCBB54', // Orange  
    '#73c5eb' // Blue 
];

var presentation10light = [ 
    '#a5e6c3', // Green
    '#eda3da', // Pink          
    '#9af8f4', // Aqua     
    '#EDC19C', // Brown         
    '#e5e5e5', // Grey 
    '#F5AAAA', // Red     
    '#F7EFC3', // Yellow           
    '#c6a8ef', // Purple      
    '#F8D296', // Orange     
    '#addbf0' // Blue 
];

var presentation20cheerios = [
    '#06A4B5',
    '#880E4F',
    '#FF5722',
    '#0097A7',
    '#AD1457',
    '#18048C',
    '#651FFF',
    '#FF3D00',
    '#00838F',
    '#C2185B',
    '#2D1B93',
    '#A30E00',
    '#E91E63',
    '#500BE8',
    '#DD2C00',
    '#0B6E7B',
    '#D81B60',
    '#3820B9',
    '#C31900',
    '#005662'
];

var names10 = {
    green:  0,
    pink:   1,
    aqua:   2,        
    brown:  3,
    grey:   4,
    red:    5,
    yellow: 6,
    purple: 7,
    orange: 8,
    blue:   9
};

var names20 = {
    aqua1: 0,
    magenta5: 1,
    orange1: 2,        
    aqua2: 3,
    magenta4: 4,
    purple5: 5,
    aqua3: 6,
    orange2: 7,
    aqua4: 8,
    magenta3: 9,
    purple4: 10,
    orange5: 11,
    magenta1: 12,
    purple2: 13,
    orange3: 14,
    aqua5: 15,
    magenta2: 16,
    purple3: 17,
    orange4: 18,
    aqua6: 19
};

var presentation10 = {
    standard: presentation10std,
    darker: presentation10dark,
    lighter: presentation10light,
    names: names10, 
};

var presentation20 = {
    cheerios: presentation20cheerios,
    names: names20 
};

var brandstd = [
    '#ed1651', // red - was e11010
    '#0ab93a', // green
    '#1671f4', // blue
    '#cacaca'  // grey
];

var branddark = [
    '#5f041f', // red - was 6a0000
    '#087927', // green
    '#0b49a2', // blue
    '#828282'  // grey
];

var namesbrand = {
    red:    0,
    green:  1,
    blue:   2,        
    grey:   3
};

var brand = { 
    standard: brandstd, 
    darker: branddark,
    names: namesbrand 
}; 

var themes = [ 'light', 'dark' ];   

var display = { 
    light : {
        background: '#ffffff',
        text: '#262626',
        axis: '#262626',
        grid: '#e0e0e0',
        highlight: 'rgba(225,16,16,0.5)',
        lowlight: 'rgba(127,127,127,0.3)',
        shadow: 'rgba(127,127,127,0.4)',
        fillOpacity: 0.33,
        negative: {
            background: 'rgba(0, 0, 0, 0.66)',
            text: '#ffffff'
        }
    },
    dark : {
        background: '#333333',    
        text: '#ffffff',
        axis: '#ffffff',
        grid: '#6d6d6d',
        highlight: 'rgba(225,16,16,0.5)',
        lowlight: 'rgba(127,127,127,0.5)',
        shadow: 'rgba(255,255,255,0.4)',
        fillOpacity: 0.33,      
        negative: {
            background: 'rgba(255, 255, 255, 0.85)',
            text: '#262626'
        }
    }
};

function interopDefault(ex) {
	return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module) {
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

function LinearEasing (x) {
  return x;
}

module.exports = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  if (mX1 === mY1 && mX2 === mY2) {
    return LinearEasing;
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  for (var i = 0; i < kSplineTableSize; ++i) {
    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};
});

var BezierEasing = interopDefault(index);

var duration = 400;

function easing() {
    return BezierEasing(0.175, 0.885, 0.335, 1.155);
}

var COUNT = 1;

function scaffold(id, onetime, dynamic, transitions) {
    function _impl(context) {
        var selection = context.selection ? context.selection() : context,
            transition = (context.selection !== undefined);

        var defs = selection.select('defs');
        if (defs.empty()) {
            defs = selection.append('defs');
        }
        
        var filter = defs.select(_impl.self());
        if (filter.empty()) {
            filter = defs.append('filter')
                        .attr('filterUnits', 'objectBoundingBox')
                        .attr('x', '0%')
                        .attr('y', '0%')
                        .attr('width', '100%')
                        .attr('height', '100%')
                        .attr('id', id);

            onetime(filter);
        }        
        
        dynamic(filter);

        if (transition === true) {
            filter = filter.transition(context);
        }
        
        transitions(filter);
    }

    _impl.id = function () { return id; };
    _impl.self = function () { return ("#" + id); };
    
    // .url() can be used with filter on a SVG component
    _impl.url = function () { return ("url(#" + id + ")"); };
    
    // .css() can be used with style on a SVG component
    _impl.css = function () { return ("fill: " + (_impl.url()) + ";"); };

    return _impl;
}

function shadow(id) {
    
    var morphRadius = 1,
        color = display.light.shadow,
        blurRadius = 3,
        padding = "10";
    
    if (id == null) {
        id = 'filter-shadow-' + COUNT;
        COUNT++;
    }
    
    var _impl = scaffold(id, 
    function onetime(filter) {
        filter.append('feMorphology')
            .attr('operator', 'dilate')
            .attr('in', 'SourceAlpha')
            .attr('result', 'TEMPLATE');

        filter.append('feFlood')
                .attr('result', 'COLOUR');

        filter.append('feComposite')
            .attr('in', 'COLOUR')
            .attr('in2', 'TEMPLATE')
            .attr('operator', 'in')
            .attr('result', 'TEMPLATE_COLOUR');

        filter.append('feGaussianBlur')
            .attr('result', 'BG');
        
        var merge = filter.append('feMerge');
        merge.append('feMergeNode').attr('in', 'BG');
        merge.append('feMergeNode').attr('in', 'SourceGraphic');
    },
    function dynamic(filter) {
        filter
            .attr('x', '-' + padding + '%')
            .attr('y', '-' + padding + '%')
            .attr('width', (2*padding + 100) + '%')
            .attr('height', (2*padding + 100) + '%');
    },
    function transition(filter) {
        filter.select('feMorphology')    
            .attr('radius', morphRadius);

        filter.select('feFlood')    
            .attr('flood-color', color);

        filter.select('feGaussianBlur')
            .attr('stdDeviation', blurRadius);
    });

    
    _impl.morphRadius = function(value) {
        return arguments.length ? (morphRadius = value, _impl) : morphRadius;
    };
    
    _impl.color = function(value) {
        return arguments.length ? (color = value, _impl) : color;
    };
    
    _impl.blurRadius = function(value) {
        return arguments.length ? (blurRadius = value, _impl) : blurRadius;
    };
    
    _impl.padding = function(value) {
        return arguments.length ? (padding = value, _impl) : padding;
    };                  

    return _impl;
}

function greyscale(id) { 
    var strength = 1.0;

    if (id == null) {
        id = 'filter-greyscale-' + COUNT;
        COUNT++;
    }

    var _impl = scaffold(id, 
    function onetime(filter) {
        filter.append('feColorMatrix')
                .attr('type', 'matrix');
    },
    function dynamic() {

    },
    function transition(filter) {
        var s = (1.0 / 3.0);

        var o = s * strength;
        var d = 1.0 - 2*o;

        filter.select('feColorMatrix')
                .attr('values', d + " " + o + " " + o + " 0 0 " +
                                o + " " + d + " " + o + " 0 0 " +
                                o + " " + o + " " + d + " 0 0 " +
                                "0 0 0 1 0");
    });

    _impl.strength = function(v) { 
        return arguments.length ? (strength = v, _impl) : strength; 
    };

    return _impl;
}

function emboss(id) { 
    var color = brand.standard[brand.names.grey],
        blur = 0.6,
        strength = 0.8;

    if (id == null) {
        id = 'filter-emboss-' + COUNT;
        COUNT++;
    }

    var _impl = scaffold(id, 
    function onetime(filter) {
        filter.append('feColorMatrix')
                .attr('type', 'matrix')
                .attr('values', "0.3333 0.3333 0.3333 0 0 " +
                                "0.3333 0.3333 0.3333 0 0 " +
                                "0.3333 0.3333 0.3333 0 0 " +
                                "0 0 0 1 0");
        
        var transfer = filter.append('feComponentTransfer');
        [ 'feFuncR', 'feFuncG', 'feFuncB' ].forEach(function (ch) {
            transfer.append(ch)
                    .attr('type', 'discrete')
                    .attr('tableValues', "0.0 0.18 0.75 1.0");
        });
    
        filter.append('feGaussianBlur')
                .attr('stdDeviation', blur);

        filter.append('feComponentTransfer')
                .attr('result', 'TRANSFER')
                .append('feFuncA')
                    .attr('type', 'discrete');

        filter.append('feFlood')
                .attr('rect', '')
                .attr('x', '0%')
                .attr('y', '0%')
                .attr('width', '100%')
                .attr('height', '100%')
                .attr('result', 'FILL');

        filter.append('feBlend')
                .attr('in', 'TRANSFER')
                .attr('in2', 'FILL')
                .attr('mode', 'multiply');
    },
    function dynamic() {

    },
    function transition(filter) {
        filter.select('feFlood').attr('flood-color', color);
        filter.select('feFuncA').attr('tableValues', ("0.0 " + strength));
    });

    _impl.color = function(v) { 
        return arguments.length ? (color = v, _impl) : color; 
    };

    _impl.strength = function(v) { 
        return arguments.length ? (strength = v, _impl) : strength; 
    };

    return _impl;
}

var angle = 33.75;

var patterns = {
    diagonal1: { angle: angle, width: 5, height: 4, size: 5 },
    diagonal2: { angle: angle, width: 5, height: 2, size: 5 },
    diagonal3: { angle: angle, width: 5, height: 3, size: 5 },
    crosshatch1: { angle: 45, width: 4, height: 4, size: 5 },
    crosshatch2: { angle: 45, width: 3, height: 4, size: 5 },
    crosshatch3: { angle: 45, width: 3, height: 3, size: 5 },
    blocks: { angle: 0, width: 3, height: 4, size: 5 },
    redsift: { angle: angle, width: 3, height: 3, size: 5 }
};

var COUNT$1 = 1;

function highlights(id) {

    var sz = 8, // size of pattern
          a = 45, // angle of pattern
          sq = 5; // size of square

    var o = (sz - sq) / 2;
    var s = 2 * Math.sqrt(sz);

    var background = 'transparent',
        foreground = display.light.highlight;
    
    if (id == null) {
        id = 'pattern-diagonals-' + COUNT$1;
        COUNT$1++;
    }
            
    function _impl(context) {
        var selection = context.selection ? context.selection() : context;
        
        var defs = selection.select('defs');
        if (defs.empty()) {
            defs = selection.append('defs');
        }
        
        var inner = id + "-inner";

        var pinner = defs.select(("#" + inner));
        if (pinner.empty()) {
            pinner = defs.append('pattern')
                    .attr('id', inner)
                    .attr('x', 0)
                    .attr('y', 0)
                    .attr('patternUnits', 'userSpaceOnUse');    
            
            pinner.append('rect');
        }

        pinner.attr('width', sz)
                .attr('height', sz)
                .attr('patternTransform', ("rotate(" + a + ")"));
        
        pinner.select('rect')
                .attr('x', o)
                .attr('y', o)
                .attr('width', sq)
                .attr('height', sq)
                .attr('fill', foreground);

        var pattern = defs.select(_impl.self());
        if (pattern.empty()) {
            pattern = defs.append('pattern')
                    .attr('id', id)
                    .attr('x', 0)
                    .attr('y', 0)
                    .attr('width', '100%')
                    .attr('height', '100%')
                    .attr('patternUnits', 'objectBoundingBox');    
            
            pattern.append('rect')
                    .attr('class', 'pattern-background')
                    .attr('x', 0)
                    .attr('y', 0)
                    .attr('width', '100%')
                    .attr('height', '100%');

            pattern.append('rect')
                    .attr('class', 'pattern-foreground')
                    .attr('x', 0)
                    .attr('y', 0)
                    .attr('width', '100%')
                    .attr('height', '100%')
                    .attr('fill', ("url(#" + inner + ")"));
        }

        pattern.select('rect.pattern-background').attr('fill', background);
    }

    _impl.id = function () { return id; };
    _impl.self = function () { return ("#" + id); };
    _impl.size = function () { return s; };
    _impl.align = function (v) { return Math.round(s * Math.ceil(v / s)); };

    // .url() can be used with filter on a SVG component
    _impl.url = function () { return ("url(#" + id + ")"); };
    
    // .css() can be used with style on a SVG component
    _impl.css = function () { return ("fill: " + (_impl.url()) + ";"); };

    _impl.foreground = function(value) {
        return arguments.length ? (foreground = value, _impl) : foreground;
    };
    
    _impl.background = function(value) {
        return arguments.length ? (background = value, _impl) : background;
    };        
                 
    return _impl;    

}

function diagonals(id, opts) {
    if (opts == null) opts = {};
    
    var s = opts.size || 4;
    var w = opts.width || 3;
    var h = opts.height || 3;
    var a = opts.angle || 45;
    
    var background = 'transparent',
        foreground = display.light.highlight;
    
    if (id == null) {
        id = 'pattern-diagonals-' + COUNT$1;
        COUNT$1++;
    }
        
    function _impl(context) {
        var selection = context.selection ? context.selection() : context;
        
        var defs = selection.select('defs');
        if (defs.empty()) {
            defs = selection.append('defs');
        }
        
        var pattern = defs.select(_impl.self());
        if (pattern.empty()) {
            pattern = defs.append('pattern')
                    .attr('id', id)
                    .attr('patternUnits', 'userSpaceOnUse');    
                    
            pattern.append('rect')
                .attr('class', 'pattern-background');
            
            pattern.append('rect')
                .attr('class', 'pattern-foreground');                        
        }
        pattern.attr('width', s)
                .attr('height', s)
                .attr('patternTransform', ("translate(" + (w*Math.sin(a * (Math.PI / 180))) + ",0),rotate(" + a + ")")); // translation ensure rects are correct

        pattern.select('rect.pattern-background')
                .attr('width', s)
                .attr('height', s)
                .attr('fill', background);

        pattern.select('rect.pattern-foreground')
                .attr('width', w)
                .attr('height', h)
                .attr('fill', foreground);
    }
    
    _impl.id = function () { return id; };
    _impl.self = function () { return ("#" + id); };
    
    // .url() can be used with filter on a SVG component
    _impl.url = function () { return ("url(#" + id + ")"); };
    
    // .css() can be used with style on a SVG component
    _impl.css = function () { return ("fill: " + (_impl.url()) + ";"); };
    
    _impl.size = function(value) {
        return arguments.length ? (s = value, _impl) : s;
    };     
      
    _impl.width = function(value) {
        return arguments.length ? (w = value, _impl) : w;
    };
     
    _impl.height = function(value) {
        return arguments.length ? (h = value, _impl) : h;
    };
     
    _impl.angle = function(value) {
        return arguments.length ? (a = value, _impl) : a;
    };
    
    _impl.foreground = function(value) {
        return arguments.length ? (foreground = value, _impl) : foreground;
    };
    
    _impl.background = function(value) {
        return arguments.length ? (background = value, _impl) : background;
    };        
                 
    return _impl;
}

var widths = {
    outline: 0.5,
    data: 2.5,
    axis: 1.0,
    grid: 2.0
};

var dashes = {
    grid: '2,2'
};

// Fallback here chooses system fonts first
var systemFontFallback = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";

function sizeForWidth(width) {
    if (width < 414) {
        return '12px';
    }
    return '14px';
}

var fonts = {
    fixed: {
        cssImport: "@import url(https://fonts.googleapis.com/css?family=Source+Code+Pro:300,500);",
        weightMonochrome: 300,
        weightColor: 500,
        sizeForWidth: sizeForWidth,
        family: "\"Source Code Pro\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace" // Font fallback chosen to keep presentation on places like GitHub where Content Security Policy prevents inline SRC
    },
    variable: {
        cssImport: "@import url(https://fonts.googleapis.com/css?family=Raleway:400,500);",
        weightMonochrome: 400,
        weightColor: 500,
        sizeForWidth: sizeForWidth,
        family: ("\"Raleway\", \"Trebuchet MS\", " + systemFontFallback)
    },
    brand: {
        cssImport: "@import url(https://fonts.googleapis.com/css?family=Electrolize);",
        weightMonochrome: 400,
        weightColor: 400,
        sizeForWidth: sizeForWidth,
        family: ("\"Electrolize\", " + systemFontFallback)
    }
};

exports.version = version;
exports.transform = Transform;
exports.random = random;
exports.contrasts = Contrasts;
exports.sort = Sort;
exports.themes = themes;
exports.presentation10 = presentation10;
exports.presentation20 = presentation20;
exports.brand = brand;
exports.display = display;
exports.duration = duration;
exports.easing = easing;
exports.shadow = shadow;
exports.greyscale = greyscale;
exports.emboss = emboss;
exports.angle = angle;
exports.patterns = patterns;
exports.diagonals = diagonals;
exports.highlights = highlights;
exports.widths = widths;
exports.dashes = dashes;
exports.fonts = fonts;

Object.defineProperty(exports, '__esModule', { value: true });

})));
